import * as React from "react";
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 54173 104599"
    {...props}
  >
    <defs>
      <style>
        {".str0{stroke:#1c1b17;stroke-width:1515.93}.fil0{fill:#2b2a29}"}
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_1970270466656">
        <path
          d="M50690 50377 29179 74984c-1108 1266-3076 1266-4181 0L3488 50377c-947-1080-2730-412-2730 1025v21942c0 1175 426 2310 1199 3194l23041 26354c1105 1266 3074 1266 4181 0l23037-26354c773-885 1199-2019 1199-3194V51402c0-1437-1779-2105-2725-1025zM1762 35850c1136-1138 2980-1138 4117 0 1140 1139 1140 2984 0 4121-1137 1138-2981 1138-4117 0-1140-1136-1140-2982 0-4121zM9517 43607c1138-1138 2982-1138 4119 0 1140 1137 1140 2982 0 4121-1137 1138-2981 1138-4119 0-1140-1139-1140-2984 0-4121z"
          className="fill stroke1s"
          style={{
            strokeWidth: 1515.93,
          }}
        />
        <path
          d="M17270 51361c1139-1137 2984-1137 4121 0 1140 1139 1140 2984 0 4121-1137 1140-2980 1140-4121 0-1137-1136-1137-2982 0-4121zM25027 59118c1140-1138 2984-1138 4121 0 1137 1139 1137 2984 0 4121s-2981 1137-4121 0c-1137-1137-1137-2982 0-4121zM52416 35850c-1137-1138-2983-1138-4121 0-1137 1139-1137 2984 0 4121 1138 1138 2984 1138 4121 0 1137-1136 1137-2982 0-4121zM44659 43607c-1137-1138-2980-1138-4120 0-1138 1137-1138 2982 0 4121 1140 1138 2983 1138 4120 0 1139-1139 1139-2984 0-4121zM36905 51361c-1138-1137-2981-1137-4121 0-1137 1139-1137 2984 0 4121 1140 1140 2983 1140 4121 0 1137-1136 1137-2982 0-4121z"
          className="fill stroke1"
          style={{
            strokeWidth: 701.482,
          }}
        />
        <path
          d="M29148 59118c-1137-1138-2981-1138-4121 0-1137 1139-1137 2984 0 4121 1140 1137 2984 1137 4121 0s1137-2982 0-4121zM1762 18731c1136-1139 2980-1139 4117 0 1140 1138 1140 2983 0 4120-1137 1139-2981 1139-4117 0-1140-1137-1140-2982 0-4120zM9517 26488c1138-1139 2982-1139 4119 0 1140 1137 1140 2982 0 4120-1137 1139-2981 1139-4119 0-1140-1138-1140-2983 0-4120zM17270 34243c1139-1138 2984-1138 4121 0 1140 1137 1140 2982 0 4121-1137 1138-2980 1138-4121 0-1137-1139-1137-2984 0-4121zM25027 41999c1140-1139 2984-1139 4121 0 1137 1138 1137 2983 0 4120-1137 1139-2981 1139-4121 0-1137-1137-1137-2982 0-4120zM52416 18731c-1137-1139-2983-1139-4121 0-1137 1138-1137 2983 0 4120 1138 1139 2984 1139 4121 0 1137-1137 1137-2982 0-4120zM44659 26488c-1137-1139-2980-1139-4120 0-1138 1137-1138 2982 0 4120 1140 1139 2983 1139 4120 0 1139-1138 1139-2983 0-4120zM36905 34243c-1138-1138-2981-1138-4121 0-1137 1137-1137 2982 0 4121 1140 1138 2983 1138 4121 0 1137-1139 1137-2984 0-4121z"
          className="fill stroke1"
          style={{
            strokeWidth: 701.482,
          }}
        />
        <path
          d="M29148 41999c-1137-1139-2981-1139-4121 0-1137 1138-1137 2983 0 4120 1140 1139 2984 1139 4121 0 1137-1137 1137-2982 0-4120zM1762 1611c1136-1138 2980-1138 4117 0 1140 1139 1140 2984 0 4122-1137 1137-2981 1137-4117 0-1140-1138-1140-2983 0-4122zM9517 9367c1138-1139 2982-1139 4119 0 1140 1138 1140 2983 0 4120-1137 1139-2981 1139-4119 0-1140-1137-1140-2982 0-4120zM17270 17124c1139-1138 2984-1138 4121 0 1140 1137 1140 2982 0 4120-1137 1139-2980 1139-4121 0-1137-1138-1137-2983 0-4120zM25027 24879c1140-1138 2984-1138 4121 0 1137 1137 1137 2982 0 4119-1137 1140-2981 1140-4121 0-1137-1137-1137-2982 0-4119zM52416 1611c-1137-1138-2983-1138-4121 0-1137 1139-1137 2984 0 4122 1138 1137 2984 1137 4121 0 1137-1138 1137-2983 0-4122zM44659 9367c-1137-1139-2980-1139-4120 0-1138 1138-1138 2983 0 4120 1140 1139 2983 1139 4120 0 1139-1137 1139-2982 0-4120zM36905 17124c-1138-1138-2981-1138-4121 0-1137 1137-1137 2982 0 4120 1140 1139 2983 1139 4121 0 1137-1138 1137-2983 0-4120z"
          className="fill stroke1"
          style={{
            strokeWidth: 701.482,
          }}
        />
        <path
          d="M29148 24879c-1137-1138-2981-1138-4121 0-1137 1137-1137 2982 0 4119 1140 1140 2984 1140 4121 0 1137-1137 1137-2982 0-4119z"
          className="fill stroke1"
          style={{
            strokeWidth: 701.482,
          }}
        />
      </g>
    </g>
  </svg>
);
export default SvgComponent;
